const focusInHandler = (event) => {
  const DateInputElement = event.target;
  DateInputElement.type = 'date';
};

const focusOutHandler = (event) => {
  const DateInputElement = event.target;
  if ($(event.target).val().length === 0) {
    DateInputElement.type = 'text';
  }
};

const handleDatePickerFocus = (dateInputs) => {
  dateInputs.forEach((dateInput) => {
    dateInput.addEventListener('focusin', focusInHandler);
    dateInput.addEventListener('focusout', focusOutHandler);
  });
};

const handleDatePickerFocusDisconnect = (dateInputs) => {
  dateInputs.forEach((dateInput) => {
    dateInput.removeEventListener('focusin', focusInHandler);
    dateInput.removeEventListener('focusout', focusOutHandler);
  });
};

export default () => {
  const dateInputs = document.querySelectorAll('.filters__input--date');
  handleDatePickerFocus(dateInputs);

  return () => {
    handleDatePickerFocusDisconnect(dateInputs);
  };
};
